// @flow
import React from 'react'
import styled from 'styled-components'
import Button from '../Button'

const Component = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Results = styled.div`
  margin: 0 1rem;
  background: #fff;
  border: 1px solid rgb(220, 225, 230);
  padding: 5px 10px;
  border-radius: 4px;
`

type Props = {
  limit: number,
  offset: number,
  style?: Object,
  results: number,
  onPrevPageClick: Function,
  onNextPageClick: Function
}

const Pager = ({
  results,
  offset,
  limit,
  onPrevPageClick,
  onNextPageClick,
  style
}: Props) => {
  const resultsStartRange = offset + 1
  const resultsEndRange =
    results < limit || offset + limit > results ? results : offset + limit
  const showPrevButton = offset >= limit
  const showNextButton = resultsEndRange < results

  return (
    <Component style={style}>
      {showPrevButton && (
        <Button onClick={onPrevPageClick}>
          <span className="fa fa-chevron-left" />
        </Button>
      )}
      <Results>
        {limit > 1 && (
          <span>
            {resultsStartRange}-{resultsEndRange} of {results}
          </span>
        )}
        {limit === 1 && (
          <span>
            {resultsStartRange} of {results}
          </span>
        )}
      </Results>
      {showNextButton && (
        <Button onClick={onNextPageClick}>
          <span className="fa fa-chevron-right" />
        </Button>
      )}
    </Component>
  )
}

export default Pager



// WEBPACK FOOTER //
// ./src/components/Pager/index.js